import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { getAccountIsRBL } from '@helpers/Accounts/getAccountIsRBL';
import { isPreApproved } from '@helpers/GetTopUpStatus/getTopUpStatus';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../iwQueryClient/useStateKey';

type TUseGetTopupRequestData = {
    isRBL: boolean;
    isPreApproved: boolean;
    approvalAmount: number;
};

export const useGetTopupRequestData = (
    accountId: NonNullable<TAccount['account_id']>
): TUseGetTopupRequestData => {
    const stateKey = useStateKey();

    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            ),
        suspense: true
    });

    if (!account) {
        throw new Error();
    }

    return {
        isRBL: getAccountIsRBL(account),
        isPreApproved: Boolean(isPreApproved(account)),
        approvalAmount: account.latest_formal_offer.available_cash || 0
    };
};
